/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PriorityBadge from "../Layout/PriorityBadge";

import {
  ArrivalDateSection,
  CheckOutTimeSection,
  CountryOfResidenceSection,
  DailyRoomRateSection,
  DepartureDateSection,
  EmailSection,
  MobileNoSection,
  NameSection,
  NationalitySection,
  NightsCountSection,
  PincodeSection,
  TotalChargesSection,
  JobTitleSection,
  UdfSection,
  Udf2Section,
  Udf3Section,
  Udf4Section,
  FirstNameSection,
  LastNameSection,
  DocumentNumberSection,
  DocumentTypeSection,
  AddressLine1Section,
  CitySection,
  StateSection,
  GenderSection,
} from "./UserReservationFields";
import {
  addPrefixIfSingleLetter,
  formatDate,
  getParametersFromLocalStorage,
  homePageHandler,
  nameValidation,
} from "../../helpers/commonHelper";
import {
  fetchCountries,
  getCountryList,
} from "../../store/Checkin/reservationformSlice";
import { initReactI18next, useTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ErrorPopup from "../LoaderAndNotification/ErrorPopup";
import Header from "../Layout/Header";
import LoaderPopup from "../LoaderAndNotification/LoaderPopup";
import PolicyDetailsModal from "../../components/Layout/Card/PolicyDetailsModal";
import SignaturePad from "../Forms/SignaturePad";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import { getTermsAndConditons } from "../../network/apiService";
import { getUserConsentMaster } from "../../network/apiService";
import i18n from "i18next";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

const UserReservationDetails = ({
  loading,
  loading2,
  loading3,
  erroModalData,
  erroModalData2,
  erroModalData3,
  closeErrorModal,
  closeErrorModal2,
  closeErrorModal3,
  openModal,
  reservationData,
  confirmationDetails,
  confirmationDetailsHandler,
  signature,
  setSignature,
  setUrl,
  url,
  gotSignature,
  userAgreed,
  greenImperativeConsent,
  marketingConsent1,
  marketingConsent2,
  regCardConsent1,
  regCardConsent2,
  regCardConsent3,
  navigateToPayment,
  handleCheckboxChange,
  handleCheckboxChange1,
  handleCheckboxChange2,
  handleCheckboxChange3,
  handleCheckboxChange4,
  handleCheckboxChange5,
  handleCheckboxChange6,
  clearSign,
  updateProfile,
  openCheckOutTimeModal,
  toggleCheckoutTimeModal,
  timeChanged,
  setTimeChanged,
  onChangeHandler,
  emailValidation,
  countryValidation,
  // nationalityValidation,
  mobileNoValidation,
  enterJobTitleValidation,
  udfFieldValidation,
  udfField2Validation,
  udfField3Validation,
  udfField4Validation,
  firstNameValidation,
  lastNameValidation,
  documentNumberValidation,
  documentTypeValidation,
  addressLine1Validation,
  cityValidation,
  enterCityValidation,
  enterStateValidation,
  enterEmailValidation,
  enterPincodeValidation,
  genderValidation,
  property,
  userData,
  countries,
  documentListTypes,
  handlebackPage,
  showModalPopup,
  countryCodeAddressUpdate,
  userConsents,
  stateList,
  checkoutTimeValidation
}) => {
  //const [userConsents, setUserConsents] = useState([]);
  const [termsAndConditionData, setTermsAndConditionData] = useState();
  const settings = getParametersFromLocalStorage("settings");
  const isCheckoutTimeEditable=
  (settings?.find(s => s.parameterName === "IsCheckoutTimeEditable")
    ?.parameterValue ?? "")
    .toLowerCase() === "true";
  const inputFieldList = getParametersFromLocalStorage("InputFieldList");
  const labelFieldList = getParametersFromLocalStorage("LabelFieldList");
  const [name, setName] = useState(false);
  const [documentTypes, setDocumentTypes] = useState(documentListTypes);
  const genderOptions = [
    { displayText: "Male", value: "M" },
    { displayText: "Female", value: "F" },
    { displayText: "Unknown", value: "U" },
  ];
  const [noOfNights, setNoOfNights] = useState(false);
  const [arrivalDate, setArrivalDate] = useState(false);
  const [departureDate, setDepartureDate] = useState(false);
  const [totalCharges, setTotalCharge] = useState(false);
  const [dailyRoomRate, setDailyRoomRate] = useState(false);
  const [checkoutTime, setCheckOutTime] = useState({
    status: false,
    isMandatory: false,
  });
  const [firstName, setFirstName] = useState({
    status: false,
    isMandatory: false,
  });
  const [lastName, setLastName] = useState({
    status: false,
    isMandatory: false,
  });
  const [documentNumber, setDocumentNumber] = useState({
    status: false,
    isMandatory: false,
  });
  const [documentType, setDocumentType] = useState({
    status: false,
    isMandatory: false,
  });
  const [addressLine1, setAddressLine1] = useState({
    status: false,
    isMandatory: false,
  });
  const [countryOfResidence, setcountryOfResidence] = useState({
    status: false,
    isMandatory: false,
  });
  const [email, setEmail] = useState({ status: false, isMandatory: false });
  const [nationality, setnationality] = useState({
    status: false,
    isMandatory: false,
  });
  const [pincode, setPincode] = useState({ status: false, isMandatory: false });
  const [mobileNo, setMobileNo] = useState({
    status: false,
    isMandatory: false,
  });
  const [jobTitle, setJobTitle] = useState({
    status: false,
    isMandatory: false,
  });
  const [udfField, setUdfField] = useState({
    status: false,
    isMandatory: false,
  });
  const [udfField2, setUdfField2] = useState({
    status: false,
    isMandatory: false,
  });
  const [udfField3, setUdfField3] = useState({
    status: false,
    isMandatory: false,
  });
  const [udfField4, setUdfField4] = useState({
    status: false,
    isMandatory: false,
  });
  const [city, setCity] = useState({ status: false, isMandatory: false });
  const [state, setState] = useState({ status: false, isMandatory: false });
  const [gender, setGender] = useState({ status: false, isMandatory: false });

  const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModel = () => {
    setIsModalOpen(false);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // const operaCheckoutTime=moment(reservationData.departureDate).format("hh:mm A");
  //const operaCheckoutTime=moment(reservationData.departureTime).format("hh:mm A");
  //const dbCheckoutTime=settings?.find((setting) => setting.parameterName === "CheckOutTime")
    //  ?.parameterValue ?? "09:00 AM";
  // const checkOutTime =
  //   settings?.find((setting) => setting.parameterName === "CheckOutTime")
  //     ?.parameterValue ?? "12:00 AM";
  // const checkOutTime =
  //  operaCheckoutTime ?? dbCheckoutTime;

  //  const checkOutTime =
  // operaCheckoutTime === "12:00 AM" || operaCheckoutTime === "00:00 AM"
  //   ? dbCheckoutTime
  //   : operaCheckoutTime;
  const [tnCLoader, setTnCLoader] = useState(false);
  const [erroModalData4, setErrorModalData4] = useState({
    toggleError: false,
    errorMessage: "",
  });

  const [showDownloadKeyModal, setDownloadKeyModal] = useState(false);
  const token = getParametersFromLocalStorage("token");
  const [totalDue, setTotalDue] = useState(0);
  const [printRate, setPrintRate] = useState(false);

  

  useEffect(() => {
    if (documentListTypes !== null && documentListTypes !== undefined) {
      setDocumentTypes(
        documentListTypes.filter(
          (obj, index, self) =>
            index === self.findIndex((o) => o.DocumentName === obj.DocumentName)
        )
      );
    }
  }, [documentListTypes]);

  useEffect(() => {
    setPrintRate(userData?.printRate);
  });

  useEffect(() => {
    labelFieldList.forEach((element) => {
      if (element.fieldCode === "fullName") {
        setName(true);
      } else if (element.fieldCode === "noOfNights") {
        setNoOfNights(true);
      } else if (element.fieldCode === "arrivalDate") {
        setArrivalDate(true);
      } else if (element.fieldCode === "departureDate") {
        setDepartureDate(true);
      } else if (element.fieldCode === "totalCharges") {
        setTotalCharge(true);
      } else if (element.fieldCode === "dailyRoomRate") {
        setDailyRoomRate(true);
      }
    });

    inputFieldList.forEach((element) => {
      if (element.fieldCode === "CheckOutTime")
        // setCheckOutTime(true);
          setCheckOutTime({
          status: true,
          isMandatory: element.isMandatory,
        });
      else if (element.fieldCode === "countryOfResidence")
        setcountryOfResidence({
          status: true,
          isMandatory: element.isMandatory,
        });
      else if (element.fieldCode === "nationality")
        setnationality({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "email")
        setEmail({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "pincode")
        setPincode({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "phoneNo_UAE")
        setMobileNo({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "jobTitle")
        setJobTitle({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "udfField")
        setUdfField({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "udfField2")
        setUdfField2({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "udfField3")
        setUdfField3({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "udfField4")
        setUdfField4({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "city")
        setCity({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "state")
        setState({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "firstName")
        setFirstName({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "lastName")
        setLastName({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "documentNumber")
        setDocumentNumber({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "documentType")
        setDocumentType({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "addressLine1")
        setAddressLine1({ status: true, isMandatory: element.isMandatory });
      else if (element.fieldCode === "gender")
        setGender({ status: true, isMandatory: element.isMandatory });
    });
  }, []);

  useEffect(() => {
    if (reservationData !== null && reservationData !== undefined) {
      const amount = parseFloat(reservationData.totalAmountDue);

      if (amount > 0) {
        setTotalDue(amount);
      } else {
        setTotalDue(0);
      }
    }
  }, [reservationData]);
  const openDownloadKey = () => {
    setDownloadKeyModal(true);
  };

  const closeDownloadKey = () => {
    setDownloadKeyModal(false);
  };

  const doneDownloadKey = () => {
    setDownloadKeyModal(false);
  };

  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  const closeErrorModal4 = () => {
    setErrorModalData4((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };

  // const fetchUserConsents = async () => {
  //   try {
  //     const response = await getUserConsentMaster(token);
  //     ;
  //     if (response.status === 200) {
  //       const responseData = response?.data;

  //       // Handle if it's an object with `.data` property (common in APIs)
  //       const consentList = Array.isArray(responseData?.data)
  //         ? responseData.data
  //         : Array.isArray(responseData)
  //         ? responseData
  //         : [];

  //       const activeConsents = consentList.filter(
  //         (consent) => consent?.isActive
  //       );

  //       console.log("activeConsents", activeConsents);
  //       setUserConsents(activeConsents);
  //     }
  //   } catch (error) {
  //     console.error("Failed to load user consents", error);
  //   }
  // };

  //console.log("All Mandatory Consents Checked:", allMandatoryChecked());

  const getTermsAndConditonsData = useCallback(async () => {
    try {
      setTnCLoader(true);
      const response = await getTermsAndConditons(token);
      if (response.status === 200) {
        const filteredData = response.data.data.filter(
          (item) => item.language === selectedLanguage
        );
        setTermsAndConditionData(filteredData);
        setTnCLoader(false);
        return;
      }
    } catch (error) {
      setTnCLoader(false);
      // console.log(error);
      setErrorModalData4((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message,
      }));
    }
    return;
  }, [token]);

  useEffect(() => {
    getTermsAndConditonsData();
  }, []);
  // useEffect(() => {
  //   fetchUserConsents();
  // }, []);

  useEffect(() => {
    if (timeChanged) {
      openCheckOutTimeModal();
    }
  }, [timeChanged]);

  const [containerHeight, setContainerHeight] = useState(0);
  const showRegCardConsent1 = userConsents.some(
    (c) => c.consentCode === "RegCardConsent1"
  );
  const isRegCardConsent1Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "RegCardConsent1" && consent.isMandatory
  );
  const showRegCardConsent2 = userConsents.some(
    (c) => c.consentCode === "RegCardConsent2"
  );
  const isRegCardConsent2Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "RegCardConsent2" && consent.isMandatory
  );
  const showRegCardConsent3 = userConsents.some(
    (c) => c.consentCode === "RegCardConsent3"
  );

  const isRegCardConsent3Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "RegCardConsent3" && consent.isMandatory
  );

  //Mandai Property - Green Imperative and Marketing Consents
  const showGreenImperativeConsent = userConsents.some(
    (c) => c.consentCode === "GreenImperativeConsent"
  );
  const isGreenImperativeConsentMandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "GreenImperativeConsent" && consent.isMandatory
  );
  const showMarketingConsent1 = userConsents.some(
    (c) => c.consentCode === "MarketingConsent1"
  );
  const isMarketingConsent1Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "MarketingConsent1" && consent.isMandatory
  );
  const showMarketingConsent2 = userConsents.some(
    (c) => c.consentCode === "MarketingConsent2"
  );
  const isMarketingConsent2Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "MarketingConsent2" && consent.isMandatory
  );

  //   const isRegCardConsent5Mandatory = userConsents.some(
  //   (consent) => consent.consentCode === "RegCardConsent5" && consent.isMandatory
  // );

  useEffect(() => {
    const calculateContainerHeight = () => {
      const footerHeight = document.querySelector("footer").clientHeight;
      const viewportHeight = window.innerHeight;
      setContainerHeight(`calc(${viewportHeight}px - ${footerHeight}px)`);
    };

    calculateContainerHeight();
    window.addEventListener("resize", calculateContainerHeight);

    return () => {
      window.removeEventListener("resize", calculateContainerHeight);
    };
  }, []);

  return (
    <div>
      <main>
        <LoaderPopup loading={loading} />
        <LoaderPopup loading={loading2} />
        <LoaderPopup loading={loading3} />
        <LoaderPopup loading={tnCLoader} />
        <ErrorPopup
          closeErrorModal={closeErrorModal}
          erroModalData={erroModalData}
        />
        {erroModalData?.toggleError && (
          <ErrorPopup
            closeErrorModal={closeErrorModal}
            erroModalData={erroModalData}
          />
        )}
        <ErrorPopup
          closeErrorModal={closeErrorModal2}
          erroModalData={erroModalData2}
        />
        <ErrorPopup
          closeErrorModal={closeErrorModal3}
          erroModalData={erroModalData3}
        />
        <ErrorPopup
          closeErrorModal={closeErrorModal4}
          erroModalData={erroModalData4}
        />
        {showDownloadKeyModal && (
          <PolicyDetailsModal
            closeDownloadKey={closeDownloadKey}
            doneDownloadKey={doneDownloadKey}
            policyData={
              Array.isArray(termsAndConditionData)
                ? termsAndConditionData[0]?.policyInfo
                : termsAndConditionData?.policyInfo
            }
          />
        )}

        <div
          className="main-content"
          style={{ height: containerHeight, overflowY: "auto" }}
        >
          <div
            style={{
              position: "absolute",
              top: "40px",
              right: "20px",
              zIndex: 10,
            }}
          >
            <PriorityBadge />
          </div>
          <div className="d-flex h-100 flex-nowrap ">
            <div className="col-6  p-2  ">
              {" "}
              <div>
                <Header
                  onClick={handlebackPage}
                  setShowModal={openModal}
                  isHome={true}
                  title={""}
                  subTitle={""}
                />
              </div>
              <form className="h-70" autoComplete="off">
                <div className="d-flex flex-column" style={{ height: "100%" }}>
                  <div
                    className="mb-20"
                    style={{
                      paddingLeft: "50px",
                      paddingRight: "50px",
                      paddingTop: "20px",
                    }}
                  >
                    <div className="terms-title">
                      <h4 className="terms-title-font-size">
                        {t("Reservation Details")}
                      </h4>
                    </div>
                    <div className="d-flex flex-wrap reservation-detail-content">
                      {name && (
                        <div className="col-md-6">
                          <NameSection reservationData={reservationData} />
                        </div>
                      )}
                      {noOfNights && (
                        <div className="col-md-6">
                          <NightsCountSection
                            reservationData={reservationData}
                          />
                        </div>
                      )}
                      {arrivalDate && (
                        <div className="col-md-6">
                          {" "}
                          <ArrivalDateSection
                            reservationData={reservationData}
                          />
                        </div>
                      )}
                      {departureDate && (
                        <div className="col-md-6">
                          <DepartureDateSection
                            reservationData={reservationData}
                          />
                        </div>
                      )}
                      {dailyRoomRate && (
                        <div className="col-md-6">
                          <DailyRoomRateSection
                            reservationData={reservationData}
                            property={property}
                          />
                        </div>
                      )}
                      {totalCharges && (
                        <div className="col-md-6">
                          <TotalChargesSection
                            property={property}
                            totalDue={totalDue}
                          />
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      <div>
                        {Array.isArray(termsAndConditionData) ? (
                          <p>{termsAndConditionData[0]?.moreInfo}</p>
                        ) : (
                          <p>{termsAndConditionData || ""}</p>
                        )}
                      </div>
                    </div>
                    {checkoutTime && (
                      <CheckOutTimeSection 
                      checkoutTimeValidation={checkoutTimeValidation}
                     // checkOutTime={checkOutTime} 
                      isMandatory={checkoutTime.isMandatory}
                      confirmationDetailsHandler={confirmationDetailsHandler}
                       confirmationDetails={confirmationDetails}
                       isEnabled={isCheckoutTimeEditable}
                      />
                    )
                    }
                   
                    {countryOfResidence.status && (
                      <CountryOfResidenceSection
                        isMandatory={countryOfResidence.isMandatory}
                        confirmationDetails={confirmationDetails}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        countryValidation={countryValidation}
                        countries={countries}
                        showModalPopup={showModalPopup}
                        countryCodeAddressUpdate={countryCodeAddressUpdate}
                      />
                    )}
                    {nationality.status && (
                      <NationalitySection
                        isMandatory={nationality.isMandatory}
                        confirmationDetails={confirmationDetails}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        countryValidation={countryValidation}
                        countries={countries}
                      />
                    )}
                    {/* {nationality.status && <NationalitySection isMandatory={nationality.isMandatory} confirmationDetails={confirmationDetails} confirmationDetailsHandler={confirmationDetailsHandler} nationalityValidation={nationalityValidation} countries={countries} />} */}

                    {email.status && (
                      <EmailSection
                        isMandatory={email.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        emailValidation={emailValidation}
                      />
                    )}
                    {mobileNo.status && (
                      <MobileNoSection
                        isMandatory={mobileNo.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        mobileNoValidation={mobileNoValidation}
                      />
                    )}
                    {jobTitle.status && (
                      <JobTitleSection
                        isMandatory={jobTitle.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        enterJobTitleValidation={enterJobTitleValidation}
                      />
                    )}
                    {udfField.status && (
                      <UdfSection
                        isMandatory={udfField.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        udfFieldValidation={udfFieldValidation}
                      />
                    )}
                    {udfField2.status && (
                      <Udf2Section
                        isMandatory={udfField2.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        udfField2Validation={udfField2Validation}
                      />
                    )}
                    {udfField3.status && (
                      <Udf3Section
                        isMandatory={udfField3.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        udfField3Validation={udfField3Validation}
                      />
                    )}
                    {udfField4.status && (
                      <Udf4Section
                        isMandatory={udfField4.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        udfField4Validation={udfField4Validation}
                      />
                    )}
                    {firstName.status && (
                      <FirstNameSection
                        isMandatory={firstName.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        firstNameValidation={firstNameValidation}
                      />
                    )}
                    {lastName.status && (
                      <LastNameSection
                        isMandatory={lastName.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        lastNameValidation={lastNameValidation}
                      />
                    )}
                    {documentType.status && (
                      <DocumentTypeSection
                        isMandatory={documentType.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        documentTypeValidation={documentTypeValidation}
                        documentListTypes={documentTypes}
                      />
                    )}
                    {documentNumber.status && (
                      <DocumentNumberSection
                        isMandatory={documentNumber.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        documentNumberValidation={documentNumberValidation}
                      />
                    )}
                    {addressLine1.status && (
                      <AddressLine1Section
                        isMandatory={addressLine1.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        addressLine1Validation={addressLine1Validation}
                      />
                    )}
                    {city.status && (
                      <CitySection
                        isMandatory={city.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        enterCityValidation={enterCityValidation}
                      />
                    )}
                    {state.status && (
                      <StateSection
                        isMandatory={state.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        enterStateValidation={enterStateValidation}
                        stateList={stateList}
                      />
                    )}
                    {pincode.status && (
                      <PincodeSection
                        isMandatory={pincode.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        enterPincodeValidation={enterPincodeValidation}
                      />
                    )}
                    {gender.status && (
                      <GenderSection
                        isMandatory={gender.isMandatory}
                        confirmationDetailsHandler={confirmationDetailsHandler}
                        confirmationDetails={confirmationDetails}
                        genderValidation={genderValidation}
                        genderOptions={genderOptions}
                      />
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="col-6 col-left-bg">
              {" "}
              <div className="terms-condition-width">
                <div>
                  <div className="terms-title">
                    <h4 className="terms-title-font-size">
                      {t("Terms and Conditions")}
                    </h4>
                    <div className="terms-condition-scroll">
                      {Array.isArray(termsAndConditionData) ? (
                        termsAndConditionData?.map((ele, idx) => (
                          <pre key={idx} className="terms-condition-content">
                            {ele.content}
                          </pre>
                        ))
                      ) : (
                        <pre className="terms-condition-content">
                          {termsAndConditionData || ""}
                        </pre>
                      )}
                    </div>
                  </div>
                </div>
                {showGreenImperativeConsent && (
                  <>
                    {t(
                      "I would like to opt out of contributing towards Green Imperative Fund (GIF)..."
                    )?.trim() === "" ||
                    t(
                      "I would like to opt out of contributing towards Green Imperative Fund (GIF)..."
                    )?.trim().length === 0 ? (
                      <> </>
                    ) : (
                      <>
                        <div className="accept-condition">
                          <input
                            id="checkbox-fields-greenImperativeConsent"
                            type="checkbox"
                            style={{ borderColor: "green" }}
                            className="accept-check"
                            checked={greenImperativeConsent}
                            onChange={handleCheckboxChange1}
                          />
                          <span>
                            {t(
                              "I would like to opt out of contributing towards Green Imperative Fund (GIF)..."
                            )}
                            <a className="more-link" onClick={handleOpenModal}>
                              {" "}
                              {t("Read more")}
                            </a>
                          </span>
                        </div>
                        <div>
                          <Modal open={isModalOpen} style={{ zIndex: "1" }}>
                            <Box
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "32%",
                                backgroundColor: "#f5f5f5",
                                border: "2px #000",
                                boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
                                padding: "50px",
                                borderRadius: "20px",
                              }}
                            >
                              {/* Close Icon */}
                              <button
                                id="btn-details-closemodel"
                                className="close-icon"
                                onClick={closeModel}
                              >
                                <CloseIcon
                                  onClick={closeModel}
                                  style={{
                                    float: "right",
                                    margin: "5px",
                                    color: "white",
                                  }}
                                />
                              </button>
                              <div style={{ textAlign: "center" }}>
                                <div style={{ textAlign: "justify" }}>
                                  <p>{t("GreenImperativeConsent")}</p>
                                </div>
                                {/* OK Button */}
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <button
                                    id="btn-details-ok"
                                    onClick={closeModel}
                                    style={{
                                      marginTop: "20px",
                                      padding: "15px",
                                      marginLeft: "15px",
                                    }}
                                    className="btn button-blue scan-btn"
                                  >
                                    {t("OK")}
                                  </button>
                                </div>
                              </div>
                            </Box>
                          </Modal>
                        </div>
                      </>
                    )}
                  </>
                )}
                {showMarketingConsent1 && (
                  <>
                    {t(
                      "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Banyan Group."
                    )?.trim() === "" ||
                    t(
                      "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Banyan Group."
                    )?.trim().length === 0 ? (
                      <> </>
                    ) : (
                      <>
                        <div className="accept-condition">
                          <input
                            id="checkbox-fields-marketingConsent1"
                            type="checkbox"
                            style={{ borderColor: "green" }}
                            className="accept-check"
                            checked={marketingConsent1}
                            onChange={handleCheckboxChange2}
                          />
                          <span>
                            {t(
                              "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Banyan Group."
                            )}
                          </span>
                        </div>
                      </>
                    )}
                  </>
                )}
                {showMarketingConsent2 && (
                  <>
                    {t(
                      "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Mandai Wildlife Reserve."
                    )?.trim() === "" ||
                    t(
                      "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Mandai Wildlife Reserve."
                    )?.trim().length === 0 ? (
                      <> </>
                    ) : (
                      <>
                        <div className="accept-condition">
                          <input
                            id="checkbox-fields-marketingConsent2"
                            type="checkbox"
                            style={{ borderColor: "green" }}
                            className="accept-check"
                            checked={marketingConsent2}
                            onChange={handleCheckboxChange3}
                          />
                          <span>
                            {t(
                              "Please tick this box if you wish to withdraw your consent to the use and disclosure of your personal data for receiving marketing materials from Mandai Wildlife Reserve."
                            )}
                          </span>
                        </div>
                      </>
                    )}
                  </>
                )}

                {showRegCardConsent1 && (
                  <div className="accept-condition">
                    <input
                      id="checkbox-fields-regCardConsent1"
                      type="checkbox"
                      style={{ borderColor: "green" }}
                      className="accept-check"
                      checked={regCardConsent1}
                      onChange={handleCheckboxChange4}
                    />
                    <span>
                      {t("RegCardConsent1")}
                      {isRegCardConsent1Mandatory && (
                        <span className="mandatory-label">
                          ({t("Required")})
                        </span>
                      )}
                    </span>
                  </div>
                )}

                {showRegCardConsent2 && (
                  <div className="accept-condition">
                    <input
                      id="checkbox-fields-regCardConsent2"
                      type="checkbox"
                      style={{ borderColor: "green" }}
                      className="accept-check"
                      checked={regCardConsent2}
                      onChange={handleCheckboxChange5}
                    />
                    <span>
                      {t("RegCardConsent2")}
                      {isRegCardConsent2Mandatory && (
                        <span className="mandatory-label">
                          ({t("Required")})
                        </span>
                      )}
                    </span>
                  </div>
                )}

                {showRegCardConsent3 && (
                  <div className="accept-condition">
                    <input
                      id="checkbox-fields-regCardConsent3"
                      type="checkbox"
                      style={{ borderColor: "green" }}
                      className="accept-check"
                      checked={regCardConsent3}
                      onChange={handleCheckboxChange6}
                    />
                    <span>
                      {t("RegCardConsent3")}
                      {isRegCardConsent3Mandatory && (
                        <span className="mandatory-label">
                          ({t("Required")})
                        </span>
                      )}
                    </span>
                  </div>
                )}

                <div className="h-100" style={{ marginTop: "22px" }}>
                  <div>
                    <div className="mt-20 d-flex justify-content-between">
                      <div className="terms-title">
                        <h4 className="terms-title-font-size">
                          {t("I accept the Terms & Conditions")} {t("and")}{" "}
                          <a onClick={openDownloadKey}>
                            <u>{t("Privacy Policy")}</u>
                          </a>
                        </h4>
                      </div>
                      <div style={{ marginRight: "0px" }}>
                        <button
                          id="btn-details-retry"
                          onClick={clearSign}
                          className="terms-retry-btn"
                        >
                          <i className="bx bx-revision"></i>
                        </button>
                      </div>
                    </div>

                    <div className="sign-wrapper">
                      <SignaturePad
                        signature={signature}
                        setSignature={setSignature}
                        gotSignature={gotSignature}
                        setUrl={setUrl}
                        url={url}
                        showRetryBtn={false}
                        fixedSignatureCanvasHeight={ zoomLevel >= 150 ? 200 : zoomLevel >= 120 ? 200 : zoomLevel >= 100 ? 200 : 380 }
                        fixedSignatureCanvasWidth={ zoomLevel >= 150 ? 500 : zoomLevel >= 120 ? 650 : zoomLevel >= 100 ? 800 : 1050 }
                      />

                      {t(
                        "I would like to receive information from hotel"
                      )?.trim() === "" ||
                      t(
                        "I would like to receive information from hotel"
                      )?.trim().length === 0 ? (
                        <> </>
                      ) : (
                        <>
                          <div className="accept-condition">
                            <input
                              id="checkbox-details-useragreed"
                              type="checkbox"
                              style={{ borderColor: "green" }}
                              className="accept-check"
                              checked={userAgreed}
                              onChange={handleCheckboxChange}
                            />
                            <span>
                              {t(
                                "I would like to receive information from hotel"
                              )}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div>
                    <div
                      className="d-flex justify-content-end"
                      style={{ marginTop: "10px" }}
                    >
                      <button
                        id="btn-details-proceed"
                        disabled={!url ? true : false} //proceed //ss
                        onClick={updateProfile}
                        className="btn button-blue confirm-number-btn"
                      >
                        {t("Proceed")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserReservationDetails;
